import { render, staticRenderFns } from "./RelatedTasksTab.vue?vue&type=template&id=436a4e64&scoped=true&"
import script from "./RelatedTasksTab.vue?vue&type=script&lang=js&"
export * from "./RelatedTasksTab.vue?vue&type=script&lang=js&"
import style0 from "./RelatedTasksTab.vue?vue&type=style&index=0&id=436a4e64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436a4e64",
  null
  
)

export default component.exports